/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function RomeroHit(props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/romerohit.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions['Armature|mixamo.com|Layer0.003'].play();
  }); 
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="mixamorigMeshes" rotation={[Math.PI / 2, 0, 0]} scale={0.01} />
        <group name="Armature" rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <primitive object={nodes.mixamorigHips} />
          <skinnedMesh name="mixamorigArms_Geo" geometry={nodes.mixamorigArms_Geo.geometry} material={materials['Skin_MAT.003']} skeleton={nodes.mixamorigArms_Geo.skeleton} />
          <skinnedMesh name="mixamorigCigar_Geo" geometry={nodes.mixamorigCigar_Geo.geometry} material={materials['Cigar_Mat.003']} skeleton={nodes.mixamorigCigar_Geo.skeleton} />
          <skinnedMesh name="mixamorigHat_Geo" geometry={nodes.mixamorigHat_Geo.geometry} material={materials['Clothes_MAT.007']} skeleton={nodes.mixamorigHat_Geo.skeleton} />
          <skinnedMesh name="mixamorigHead_Geo" geometry={nodes.mixamorigHead_Geo.geometry} material={materials['Skin_MAT.003']} skeleton={nodes.mixamorigHead_Geo.skeleton} />
          <skinnedMesh name="mixamorigJacket_Geo" geometry={nodes.mixamorigJacket_Geo.geometry} material={materials['Clothes_MAT.006']} skeleton={nodes.mixamorigJacket_Geo.skeleton} />
          <skinnedMesh name="mixamorigL_Eye_Geo" geometry={nodes.mixamorigL_Eye_Geo.geometry} material={materials['Eyes_MAT.007']} skeleton={nodes.mixamorigL_Eye_Geo.skeleton} />
          <skinnedMesh name="mixamorigPants_Geo" geometry={nodes.mixamorigPants_Geo.geometry} material={materials['Clothes_MAT.007']} skeleton={nodes.mixamorigPants_Geo.skeleton} />
          <skinnedMesh name="mixamorigR_Eye_Geo" geometry={nodes.mixamorigR_Eye_Geo.geometry} material={materials['Eyes_MAT.006']} skeleton={nodes.mixamorigR_Eye_Geo.skeleton} />
          <skinnedMesh name="mixamorigShoes_Geo" geometry={nodes.mixamorigShoes_Geo.geometry} material={materials['Clothes_MAT.007']} skeleton={nodes.mixamorigShoes_Geo.skeleton} />
          <skinnedMesh name="mixamorigTeeth_Down_Geo" geometry={nodes.mixamorigTeeth_Down_Geo.geometry} material={materials['Skin_MAT.003']} skeleton={nodes.mixamorigTeeth_Down_Geo.skeleton} />
          <skinnedMesh name="mixamorigTeeth_Up_Geo" geometry={nodes.mixamorigTeeth_Up_Geo.geometry} material={materials['Skin_MAT.003']} skeleton={nodes.mixamorigTeeth_Up_Geo.skeleton} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/romerohit.glb')
